// @core/api/endpoints/workflow/delete_schedule.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/workflow';

/**
 * Delete schedule
 * Deletes a pipeline schedule. Future scheduled executions are cancelled.
 */
export async function DeleteSchedule(
  schedule_id: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/workflows/schedules/:schedule_id`;
  requestPath = requestPath.replace(':schedule_id', encodeURIComponent(schedule_id));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
